import React, { useState } from "react";
import { Flex } from "lib";
import { SwatchesPicker } from "react-color";
import { Range } from "react-range";

import Demo from "./Demo";

const ThemeConfiguration = ({ params, onChange }: any) => {
  const applyValue = (field: string, value: string | number) => {
    let newParams = {
      ...params
    };

    newParams[field] = value;

    onChange(newParams);
  };

  return (
    <aside
      style={{
        width: 400,
        backgroundColor: "#26324b",
        color: "white",
        position: "fixed",
        overflow: "scroll",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        padding: 40,
        fontSize: 20
      }}
    >
      <h2 style={{ marginBottom: 32 }}>Theme</h2>

      <div style={{ marginBottom: 32 }}>
        <label
          htmlFor="input--baseFontSize"
          style={{ display: "block", marginBottom: 16 }}
        >
          Base Font Size
        </label>
        <Range
          min={10}
          max={40}
          step={1}
          values={[params.baseFontSize]}
          onChange={(values: number[]) => applyValue("baseFontSize", values[0])}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "2px",
                width: "100%",
                borderRadius: "2px",
                backgroundColor: "#ccc"
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "16px",
                width: "16px",
                borderRadius: "16px",
                backgroundColor: "white"
              }}
            />
          )}
        />
        {params.baseFontSize}
      </div>

      <div style={{ marginBottom: 32 }}>
        <label
          htmlFor="input--textScale"
          style={{ display: "block", marginBottom: 16 }}
        >
          Text Scale
        </label>
        <Range
          min={1.1}
          max={1.62}
          step={0.01}
          values={[params.textScale]}
          onChange={(values: number[]) => applyValue("textScale", values[0])}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "2px",
                width: "100%",
                borderRadius: "2px",
                backgroundColor: "#ccc"
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "16px",
                width: "16px",
                borderRadius: "16px",
                backgroundColor: "white"
              }}
            />
          )}
        />
        {params.textScale}
      </div>
      <div style={{ marginBottom: 32 }}>
        <label
          htmlFor="input--mobileTextScale"
          style={{ display: "block", marginBottom: 16 }}
        >
          Mobile Text Scale
        </label>
        <Range
          min={0.8}
          max={1.62}
          step={0.01}
          values={[params.mobileTextScale]}
          onChange={(values: number[]) =>
            applyValue("mobileTextScale", values[0])
          }
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "2px",
                width: "100%",
                borderRadius: "2px",
                backgroundColor: "#ccc"
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "16px",
                width: "16px",
                borderRadius: "16px",
                backgroundColor: "white"
              }}
            />
          )}
        />
        {params.mobileTextScale}
      </div>

      <div>
        <label style={{ display: "block", marginBottom: 16 }}>
          Primary Color
        </label>
        <SwatchesPicker
          height={-1}
          color={params.primaryColor}
          onChangeComplete={color => applyValue("primaryColor", color.hex)}
        />
      </div>
    </aside>
  );
};

const App = () => {
  const [themeParams, setThemeParams] = useState({
    baseFontSize: 22,
    textScale: 1.33,
    mobileTextScale: 1.1,
    primaryColor: "#7b35f6"
  });
  return (
    <Flex>
      <div
        style={{
          position: "fixed",
          left: 400,
          right: 0,
          top: 0,
          bottom: 0,
          overflow: "auto"
        }}
      >
        <Demo params={themeParams} />
      </div>
      <ThemeConfiguration
        params={themeParams}
        onChange={(params: any) => setThemeParams(params)}
      />
    </Flex>
  );
};

export default App;
